import { Modal, Text } from "@shopify/polaris";
import useLocales from "../../../hooks/useLocales";
import { useState } from "react";
import styled from "styled-components";

const StarContainer = styled.div`
  text-align: center;
  padding: 16px 0;
`;

const Star = styled.span`
  font-size: 32px;
  cursor: pointer;
  color: ${(props) => (props.filled ? "#FFD700" : "#CCCCCC")};
  transition: transform 0.2s ease-in-out;
  display: inline-block;

  &:hover {
    transform: scale(1.2);
  }
`;

const SetRatingModal = ({ open, onClose, rating, onChangeRating, handleShowWriteReview }) => {
  const { translate } = useLocales();
  const [hoverRating, setHoverRating] = useState(0);
  const STAR_RATING = [1, 2, 3, 4, 5];

  const handleChangeRating = (value) => {
    onChangeRating(value || 0);
  };

  const sendRating = () => {
    handleShowWriteReview(rating);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={translate("page.dashboard.ask-rating-modal-title")}
      primaryAction={{
        content: translate("page.dashboard.review-modal-button"),
        onAction: sendRating,
        disabled: !rating,
      }}
    >
      <Modal.Section>
        <Text variant="bodyMd">{translate("page.dashboard.ask-rating-modal-body")}</Text>
        <StarContainer>
          {STAR_RATING.map((star) => (
            <Star
              key={star}
              filled={star <= (hoverRating || rating)}
              onMouseEnter={() => setHoverRating(star)}
              onMouseLeave={() => setHoverRating(0)}
              onClick={() => handleChangeRating(star)}
            >
              ★
            </Star>
          ))}
        </StarContainer>
      </Modal.Section>
    </Modal>
  );
};

export default SetRatingModal;
